import React from "react";
import { HelpPanel } from "@amzn/awsui-components-console";
import { ExternalLinkGroup } from "../../commons";
import { learnMoreLinks } from "src/pages/commons/learn-more-links";

export function ToolsContent() {
  return (
    <HelpPanel
      header={<h2>View FixedFee Config</h2>}
      footer={<ExternalLinkGroup items={learnMoreLinks} />}
    >
      <p>
        View details about a specific FixedFee Config given its FixedFee ID.
      </p>
    </HelpPanel>
  );
}
